import React from 'react';
import Form from 'components/FeaturedAd/FeaturedAdComponent/Form';

const AddFeaturedAd = ({ history }) => <Form history={history} formType={'update'} />;

export default AddFeaturedAd;
